import { useEffect, useState } from "react";
import { cancelBookingByToken } from "../api/cancel_bookings";
import { CircularProgress, Typography, Box, Paper } from "@mui/material";

const CancelBooking = () => {
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (!token) {
      setStatus("error");
      return;
    }

    cancelBookingByToken(token)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#0B1F33",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Box textAlign="center">
        {/* ✅ Logo */}
        <img
          src="/media/logo.png"
          alt="Traderly Logo"
          style={{ height: "40px", margin: "0 auto 24px auto", display: "block" }}
        />

        {/* ✅ Message Box */}
        <Paper
          elevation={4}
          sx={{
            maxWidth: 500,
            padding: 4,
            borderRadius: 4,
            backgroundColor: "white",
            textAlign: "center",
          }}
        >
          {status === "loading" && (
            <>
              <CircularProgress color="primary" />
              <Typography variant="body1" mt={2} color="textSecondary">
                Processing your cancellation...
              </Typography>
            </>
          )}

          {status === "success" && (
            <>
              <Typography variant="h5" color="green" fontWeight="bold">
                Booking Cancelled
              </Typography>
              <Typography variant="body1" mt={2}>
                Your booking was successfully cancelled.
              </Typography>
            </>
          )}

          {status === "error" && (
            <>
              <Typography variant="h5" color="error" fontWeight="bold">
                Unable to Cancel
              </Typography>
              <Typography variant="body1" mt={2}>
                This cancellation link is invalid or has expired. Please contact the business directly if needed.
              </Typography>
            </>
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default CancelBooking;
